<template>
  <v-container class="transparent">
    <v-row>
      <v-col cols="4">
        <div class="glass-card" style="height: 100%">
          <v-card class="transparent" height="100%" elevation="16">
            <v-card-title class="font-weight-bold justify-center">LOC's registradas por mes</v-card-title>
            <v-card-text>
              <apexchart width="100%" type="area" :options="options" :series="series"></apexchart>
            </v-card-text>
            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn icon class="secondary--text mt-16" to="/chartExample" outlined
                ><v-icon>mdi-cube-outline</v-icon></v-btn
              >
            </v-card-actions>
          </v-card>
        </div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <div class="glass-card">
              <v-card class="transparent" elevation="8">
                <v-card-title class="font-weight-bold justify-center">Estatus general de armas</v-card-title>
                <v-card-text>
                  <apexchart height="100%" type="bar" :options="options2" :series="series2"></apexchart>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="glass-card" style="height: 100%">
              <v-card class="transparent" height="100%">
                <v-card-title class="subtitle-1 font-weight-bold justify-center">Gráfica 3</v-card-title>
                <v-card-text>
                  <apexchart width="100%" height="100%" type="donut" :options="options3" :series="series3"></apexchart>
                </v-card-text>
                <v-card-actions class="pa-4 justify-center">
                  <v-btn class="secondary primary--text elevation-8 mt-5">Ver detalles</v-btn>
                </v-card-actions>
              </v-card>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="glass-card" style="height: 100%">
              <v-card class="transparent" height="100%">
                <v-card-title class="subtitle-1 font-weight-bold justify-center">Personal activo</v-card-title>
                <v-card-text>
                  <apexchart width="100%" type="radialBar" :options="options4" :series="series4"></apexchart>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="4">
        <div class="glass-card" style="height: 100%">
          <v-card color="transparent" height="100%">
            <v-card-title class="font-weight-bold justify-center">Ubicación de elementos</v-card-title>
            <v-card-text style="height: 80%">
              <map-component></map-component>
            </v-card-text>
          </v-card>
        </div>
      </v-col>
      <v-col cols="6">
        <v-card color="primary" class="card" height="100%">
          <v-card-title class="font-weight-bold justify-center">Últimos movimientos</v-card-title>
          <v-card-text>
            <v-list color="primary" class="inset-card">
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-ammunition</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 45 min</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>Se asignaron 50 municiones al elemento Gustavo Mitre</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-book</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 2 hrs</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>Se asignaron 50 municiones al elemento Gustavo Mitre</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-pistol</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 10 hrs</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>Se asignaron 50 municiones al elemento Gustavo Mitre</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-avatar color="secondary">
                    <v-icon color="primary">mdi-ammunition</v-icon>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <div class="text-caption">Hace 1 día</div>
                  </v-list-item-subtitle>
                  <v-list-item-title>Se asignaron 50 municiones al elemento Gustavo Mitre</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn text> Ver detalles</v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-row class="align-stretch">
          <v-col cols="5">
            <v-card color="primary" class="card fill-height">
              <v-card-title class="subtitle-1 font-weight-bold justify-center">Personal con más armas</v-card-title>
              <v-card-text>
                <v-list-item class="dashboard-list mt-6 justify-center align-center">
                  <v-list-item-avatar>
                    <v-icon>mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>John Doe</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="7">
            <v-card color="primary" class="card fill-height">
              <v-card-title class="subtitle-1 font-weight-bold justify-center"
                >Ubicación con más elementos activos</v-card-title
              >
              <v-card-text>
                <v-list-item class="dashboard-list mt-6 justify-center align-center">
                  <v-list-item-avatar>
                    <v-icon>mdi-map-marker</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>Ubicación A</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn text>Ver en mapa</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card color="primary" class="card">
              <v-card-title class="font-weight-bold justify-center">Municiones disponibles</v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="3" align="center">
                      <div class="text-caption">ARMAS CORTAS</div>
                      <v-card class="inset-card">
                        <v-card-text align="center">
                          <v-avatar>
                            <v-icon>mdi-pistol</v-icon>
                          </v-avatar>
                          <v-avatar rounded>
                            <div class="text-h6 font-weight-bold">62</div>
                          </v-avatar>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3" align="center">
                      <div class="text-caption">ARMAS LARGAS</div>
                      <v-card class="inset-card">
                        <v-card-text align="center">
                          <v-avatar>
                            <v-icon>mdi-pistol</v-icon>
                          </v-avatar>
                          <v-avatar rounded>
                            <div class="text-h6 font-weight-bold">62</div>
                          </v-avatar>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3" align="center">
                      <div class="text-caption">MUNICION X</div>
                      <v-card class="inset-card">
                        <v-card-text align="center">
                          <v-avatar>
                            <v-icon>mdi-ammunition</v-icon>
                          </v-avatar>
                          <v-avatar rounded>
                            <div class="text-h6 font-weight-bold">62</div>
                          </v-avatar>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="3" align="center">
                      <div class="text-caption">MUNICION Y</div>
                      <v-card class="inset-card">
                        <v-card-text align="center">
                          <v-avatar>
                            <v-icon>mdi-ammunition</v-icon>
                          </v-avatar>
                          <v-avatar rounded>
                            <div class="text-h6 font-weight-bold">62</div>
                          </v-avatar>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
// import LoaderComponent from '../components/LoaderComponent'
import MapComponent from '../../components/MapComponent'

export default {
  components: {
    // LoaderComponent,
    MapComponent,
  },

  data() {
    return {
      items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
      options: {
        chart: {
          id: 'vuechart-example',
          background: 'transparent',
          foreColor: '#E0E0E0',
        },

        markers: {
          size: 0,
        },
        xaxis: {
          categories: ['Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic', 'Ene'],
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
        },
        theme: {
          mode: 'dark',
          palette: 'palette2',
          monochrome: {
            enabled: true,
            color: '#6C5CE7',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },
        grid: {
          borderColor: 'rgba(108, 92, 231, 0.1)',
        },
      },
      series: [
        {
          type: 'line',
          name: 'Licencias registradas',
          data: [40, 80, 45, 64, 74, 20, 57, 32],
        },
        {
          type: 'column',
          name: 'Total de armas',
          data: [30, 40, 45, 50, 49, 60, 70, 91],
        },
      ],

      options2: {
        chart: {
          type: 'bar',
          background: 'transparent',
          foreColor: '#E0E0E0',
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['Activas', 'Inactivas'],
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
        },
        yaxis: {
          labels: {
            style: {
              colors: '#E0E0E0',
            },
          },
        },
        theme: {
          mode: 'dark',
          monochrome: {
            enabled: true,
            color: '#6C5CE7',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },
        grid: {
          borderColor: 'rgba(108, 92, 231, 0.1)',
        },
      },

      series2: [
        {
          type: 'column',
          data: [460, 80],
        },
      ],

      options3: {
        chart: {
          type: 'donut',
          background: 'transparent',
          foreColor: '#E0E0E0',
        },
        labels: ['Armas', 'Municiones'],
        stroke: {
          lineCap: 'round',
        },
        legend: {
          labels: {
            colors: '#E0E0E0',
          },
        },
        theme: {
          mode: 'dark',
          monochrome: {
            enabled: true,
            color: '#6C5CE7',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },
      },

      series3: [70, 10],

      options4: {
        series: [67],
        colors: ['#6C5CE7'],
        chart: {
          background: 'transparent',
          foreColor: '#E0E0E0',
        },
        plotOptions: {
          radialBar: {
            startAngle: -60,
            endAngle: 60,
            track: {
              background: 'rgba(108, 92, 231, 0.1)',
              startAngle: -60,
              endAngle: 60,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                fontSize: '30px',
                show: true,
                color: '#E0E0E0',
              },
            },
          },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'dark',
            type: 'horizontal',
            gradientToColors: ['#A29BFE'],
            stops: [0, 100],
          },
        },
        stroke: {
          lineCap: 'round',
        },
        labels: ['Progress'],
        theme: {
          mode: 'dark',
          monochrome: {
            enabled: true,
            color: '#6C5CE7',
            shadeTo: 'dark',
            shadeIntensity: 0.65,
          },
        },
      },

      series4: [62],
    }
  },
}
</script>

<style scoped>
/* Estilos modernos de glass-morphism para el Dashboard */
.glass-card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2) !important;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.glass-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 48px rgba(108, 92, 231, 0.3);
  border-color: rgba(108, 92, 231, 0.4) !important;
}

/* Tarjetas del Dashboard */
.card {
  background: rgba(30, 30, 46, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(108, 92, 231, 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 48px rgba(108, 92, 231, 0.2);
}

/* Tarjetas internas */
.inset-card {
  background: rgba(18, 18, 18, 0.5) !important;
  border-radius: 12px;
  border: 1px solid rgba(108, 92, 231, 0.15);
}

/* Avatares con efecto de brillo */
.v-avatar {
  box-shadow: 0 4px 16px rgba(108, 92, 231, 0.3);
  transition: all 0.3s ease;
}

.v-avatar:hover {
  box-shadow: 0 6px 24px rgba(108, 92, 231, 0.5);
  transform: scale(1.05);
}

/* Botones */
.v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s ease;
}

.v-btn:hover {
  background: rgba(108, 92, 231, 0.2) !important;
  transform: translateY(-2px);
}

/* Dividers sutiles */
.v-divider {
  border-color: rgba(108, 92, 231, 0.1) !important;
}

/* Lista del dashboard */
.dashboard-list {
  padding: 8px 0;
}

::v-deep .v-list-item {
  border-radius: 12px;
  margin: 4px 0;
  transition: all 0.3s ease;
  background: rgba(18, 18, 18, 0.3) !important;
  border: 1px solid rgba(108, 92, 231, 0.1);
}

::v-deep .v-list-item:hover {
  background: rgba(108, 92, 231, 0.15) !important;
  border-color: rgba(108, 92, 231, 0.3);
  transform: translateX(4px);
}

/* Títulos de tarjetas */
.v-card-title {
  color: #e0e0e0 !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.v-card-subtitle {
  color: rgba(224, 224, 224, 0.7) !important;
}

/* Text captions */
.text-caption {
  color: rgba(224, 224, 224, 0.6) !important;
}

/* Contenido de las tarjetas */
.v-card-text {
  color: rgba(224, 224, 224, 0.85) !important;
}

/* Iconos */
.v-icon {
  transition: all 0.3s ease;
  color: #e0e0e0;
}

.v-icon:hover {
  color: #6c5ce7 !important;
}

::v-deep .v-btn:hover .v-icon,
::v-deep .v-list-item:hover .v-icon {
  color: #6c5ce7 !important;
}

/* Avatares con glow mejorado */
::v-deep .v-avatar {
  box-shadow: 0 4px 16px rgba(108, 92, 231, 0.3);
  transition: all 0.3s ease;
  border: 2px solid rgba(108, 92, 231, 0.2);
}

::v-deep .v-avatar:hover {
  box-shadow: 0 6px 24px rgba(108, 92, 231, 0.6);
  transform: scale(1.1) rotate(5deg);
  border-color: rgba(108, 92, 231, 0.4);
}

/* Botones con ripple effect */
::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

/* Scrollbar personalizada */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(108, 92, 231, 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(108, 92, 231, 0.6);
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
